<template>

    <div class="shop_order-view">

 <Transition name="topOpen">
    <div v-if="showAddress" class="openProductModal pc-right_modal">
        <div class="button_go_back" @click="openAddress();">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polyline points="15 18 9 12 15 6"></polyline></svg> 
          <span>Назад</span>
          <span class="button_go_back_title">Адрес доставки</span>
        </div>
        <Address_list :isMobile="isMobile" :address="address" @changeAddress="changeAddress"/>
    </div>
</Transition>

      <div class="shop_order-title">Информация о заказе</div>

      <div class="shop_order-info">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80994 2L5.18994 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.1899 2L18.8099 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 7.84998C2 5.99998 2.99 5.84998 4.22 5.84998H19.78C21.01 5.84998 22 5.99998 22 7.84998C22 9.99998 21.01 9.84998 19.78 9.84998H4.22C2.99 9.84998 2 9.99998 2 7.84998Z" stroke="currentColor" stroke-width="1.5"/><path d="M9.76001 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M14.36 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
        <div class="shop_order-info_content">
          <div class="shop_order-info_title">Номер заказа</div>
          <div class="shop_order-info_value">{{ order.id }}</div>
        </div>
      </div>

      <div class="shop_order-info" @click="openDeliveryType()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.001 2V12C15.001 13.1 14.101 14 13.001 14H2.00098V6C2.00098 3.79 3.79098 2 6.00098 2H15.001Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.001 14V17C22.001 18.66 20.661 20 19.001 20H18.001C18.001 18.9 17.101 18 16.001 18C14.901 18 14.001 18.9 14.001 20H10.001C10.001 18.9 9.10098 18 8.00098 18C6.90098 18 6.00098 18.9 6.00098 20H5.00098C3.34098 20 2.00098 18.66 2.00098 17V14H13.001C14.101 14 15.001 13.1 15.001 12V5H16.841C17.561 5 18.221 5.39001 18.581 6.01001L20.291 9H19.001C18.451 9 18.001 9.45 18.001 10V13C18.001 13.55 18.451 14 19.001 14H22.001Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.00098 22C9.10555 22 10.001 21.1046 10.001 20C10.001 18.8954 9.10555 18 8.00098 18C6.89641 18 6.00098 18.8954 6.00098 20C6.00098 21.1046 6.89641 22 8.00098 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.001 22C17.1055 22 18.001 21.1046 18.001 20C18.001 18.8954 17.1055 18 16.001 18C14.8964 18 14.001 18.8954 14.001 20C14.001 21.1046 14.8964 22 16.001 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.001 12V14H19.001C18.451 14 18.001 13.55 18.001 13V10C18.001 9.45 18.451 9 19.001 9H20.291L22.001 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <div class="shop_order-info_content">
          <div class="shop_order-info_title">Способ получения</div>
          <div v-if="delivery_type == 0" class="shop_order-info_value">Доставка</div>
          <div v-else class="shop_order-info_value">Самовывоз</div>

        </div>
        <div class="shop_order-info_edit">Изменить</div>
      </div>

      <div class="shop_delivery-type_select">
            <div class="shop_delivery-type_select_item" @click="changeDelivery(0)">Доставка</div>
            <div class="shop_delivery-type_select_item" @click="changeDelivery(1)">Самовывоз</div>
        </div>


      <div class="shop_order-info" v-if="delivery_type == 0">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.71 15.18L12.61 13.33C12.07 13.01 11.63 12.24 11.63 11.61V7.51001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
<div class="shop_order-info_content">
          <div class="shop_order-info_title">Время доставки</div>
          <div class="shop_order-info_value">Сегодня с 10:00 до 23:00</div>
        </div>
      </div>
      <div class="shop_order-info" @click="openAddress()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9999 13.4299C13.723 13.4299 15.1199 12.0331 15.1199 10.3099C15.1199 8.58681 13.723 7.18994 11.9999 7.18994C10.2768 7.18994 8.87988 8.58681 8.87988 10.3099C8.87988 12.0331 10.2768 13.4299 11.9999 13.4299Z" stroke="currentColor" stroke-width="1.5"/><path d="M3.61995 8.49C5.58995 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.38995 20.54C5.62995 17.88 2.46995 13.57 3.61995 8.49Z" stroke="currentColor" stroke-width="1.5"/></svg>
<div class="shop_order-info_content" >
          <div class="shop_order-info_title" v-if="delivery_type == 0">Адрес доставки</div>
          <div class="shop_order-info_title" v-else>Адрес магазина</div>
          
          <div class="shop_order-info_value" v-if="deliveryAddress != null && delivery_type == 0">{{ deliveryAddress.address + ', '+ deliveryAddress.apart }}</div>
          <div class="shop_order-info_value" v-else-if="shop.shop_address != null && delivery_type == 1">{{ shop.shop_address }}</div>
          <div class="shop_order-info_value" v-else>Не указан</div>
        </div>
        <div v-if="delivery_type == 0" class="shop_order-info_edit">Изменить</div>
      </div>
      
      <div class="shop_order-title">Способы оплаты</div>
      <div class="shop_order-select_method_pay">

        <label v-bind:key="0" class="red">
        
          <input type="radio" v-model="payMethod" value="0" name="payMethod" />
          <span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.04 13.55C17.62 13.96 17.38 14.55 17.44 15.18C17.53 16.26 18.52 17.05 19.6 17.05H21.5V18.24C21.5 20.31 19.81 22 17.74 22H6.26C4.19 22 2.5 20.31 2.5 18.24V11.51C2.5 9.44001 4.19 7.75 6.26 7.75H17.74C19.81 7.75 21.5 9.44001 21.5 11.51V12.95H19.48C18.92 12.95 18.41 13.17 18.04 13.55Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.5 12.4101V7.8401C2.5 6.6501 3.23 5.59006 4.34 5.17006L12.28 2.17006C13.52 1.70006 14.85 2.62009 14.85 3.95009V7.75008" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.5588 13.9702V16.0302C22.5588 16.5802 22.1188 17.0302 21.5588 17.0502H19.5988C18.5188 17.0502 17.5288 16.2602 17.4388 15.1802C17.3788 14.5502 17.6188 13.9602 18.0388 13.5502C18.4088 13.1702 18.9188 12.9502 19.4788 12.9502H21.5588C22.1188 12.9702 22.5588 13.4202 22.5588 13.9702Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 12H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

            Наличными</span>
        </label>
        <label v-bind:key="1" class="blue">
          
          <input type="radio" v-model="payMethod" value="1" name="payMethod" />
          <span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.00049 8.50494H22.0005" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.00049 16.5049H8.00049" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.5005 16.5049H14.5005" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.44049 3.50494H17.5505C21.1105 3.50494 22.0005 4.38494 22.0005 7.89494V16.1049C22.0005 19.6149 21.1105 20.4949 17.5605 20.4949H6.44049C2.89049 20.5049 2.00049 19.6249 2.00049 16.1149V7.89494C2.00049 4.38494 2.89049 3.50494 6.44049 3.50494Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

            Картой <p class="ml-1" v-if="delivery_type == 0">курьеру</p></span>
        </label>

      </div>
      <div class="shop_order-finish_info">
        <div class="shop_order-finish_info-title">Сумма заказа</div>
        <div class="shop_order-finish_info-value">{{ cartSum }} ₽</div>
      </div>
      <div class="shop_order-finish_info">
        <div class="shop_order-finish_info-title">Доставка</div>
        <div class="shop_order-finish_info-value">{{ (delivery_sum == 0) ? 'Бесплатно' : delivery_sum+' ₽' }}</div>
      </div>
      <div class="shop_order-finish_info" >
        <div class="shop_order-finish_info-title">Скидка</div>
        <div class="shop_order-finish_info-value">0 ₽</div>
      </div>

      <div class="shop_order-finish_info total">
        <div class="shop_order-finish_info-title">Общая сумма заказа</div>
        <div class="shop_order-finish_info-value">{{ getCartSum(activeCart) }} ₽</div>
      </div>

        <button class="order_btn_send" @click="sendOrder()">Оформить заказ</button>
    </div>
    
    </template>

    <script>
    import Address_list from '../user/modules/Address_list.vue';
    export default {
       name: 'CartOrder',
       components: { Address_list },
        data(){
        return {
          showAddress: false,
            delivery_type: 0,
            delivery_sum: 0,
            cartSum: 0,
            shop: [],
            payMethod: 0,
            deliveryAddress: null,
            address: []
        }
       },
       mounted(){
        this.getShopInfo()
        this.getAddress()
       },
       methods: {
        sendOrder(){
          var deliAddress = { 'address': this.shop.shop_address }
          if(this.delivery_type == 0){
            deliAddress = this.deliveryAddress
          }
      
          axios.post(
'/api/cart.create.order', {'cart': this.orderType ?? 'market', 'delivery_type':this.delivery_type, 'delivery_address': deliAddress, 'pay_method': this.payMethod}
).then( response => {
  if(response.data.status == 'error'){
    return this.$bvToast.toast(response.data.messange, {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
  }
  if(response.data.status == 'success'){
    
       this.$emit('hideCart', 'reload') 
       return this.$bvToast.toast(response.data.messange, {
          title: 'Оповещение',
          variant: 'success',
          visible: true
        })
  }
})
        },
        getCartSum(id){
      let arr = this.carts
      let sum = 0
      arr.forEach(function(elem) {
        if(elem.market_id == id){
        if(elem.type == 'market'){
                var pPrice = elem.market_price.price
            }else{
                var pPrice = elem.shop_price.price
            }
          sum = sum + (elem.count * parseInt(pPrice))
          }
});
this.cartSum = sum;
return sum + this.delivery_sum
    },
        changeAddress(type, address = []){
          this.openAddress()
          if(type == 'update'){
            this.getAddress()
          }else{
            this.deliveryAddress = address
          }
        },
        openAddress(){
          if(this.delivery_type == 1){
              return;
          }
            if(this.showAddress == true){
                this.showAddress = false
            }else{
                this.showAddress = true
            }  
        },
        getAddress(){
          axios.post(
'/api/user.get.address'
).then( response => {
  this.deliveryAddress = response.data.active
  this.address = response.data.all
})
        },
      openDeliveryType(){
        const sdts = document.querySelector('.shop_delivery-type_select');
        sdts.classList.toggle("active");
      },
        changeDelivery(type){
          this.openDeliveryType()
          this.delivery_type = type;
          if(this.cartSum >= this.shop.delivery_free){
            this.delivery_sum = 0;
          }else{
            this.delivery_sum = this.shop.delivery_price
          }
        },
        getShopInfo(){
          if(this.orderType == 'shop'){
            axios.post(
'/api/shop.get.info'
).then( response => {
  if(response.data.status == 'success'){
    this.shop = response.data.info
    this.delivery_sum = response.data.info.delivery_price
  }
})
          }else{
            axios.post(
'/api/market.get.info'
).then( response => {
  if(response.data.status == 'success'){
    this.shop = response.data.info
    this.delivery_sum = 0
  }
})
          }
         


        }
       },
       props: ['carts', 'order', 'isMobile', 'activeCart', 'orderType'],
       emits: ['getCart', 'hideCart'],
       beforeRouteUpdate(to, from, next) {
      if(to.name == 'shop.product.show'){
      this.$route.params.id = to.params.id
      this.product_id = to.params.id
      this.medias = []
      this.chars = [],
            this.isTab = 'tab1',
            this.breadCrumbs = [],
            this.cat_id = 0,
            this.swiper = null,
            this.swiperthumbs = null
      this.getProduct()
        this.productCrumbs()
        this.activeSlider()
    }
    next()
  }
    }
    </script>
    
    <style scoped>
    
    </style>
    